export interface SectionJump {
  id: string;
  label: string;
  count: number;
}

export interface SectionJumpGroup {
  label?: string;
  sections: SectionJump[];
}

export default function SectionJumps({ groups }: { groups: SectionJumpGroup[] }) {
  if (!groups.length) return null;

  return (
    <nav aria-label="Jump to training section" className="mt-4 mb-6 flex flex-col gap-4 sm:flex-row sm:items-start sm:gap-5">
      {groups.map((group, index) => (
        <div key={group.label ?? String(index)} className={index > 0 ? 'sm:border-l sm:border-gray-200 sm:pl-5' : undefined}>
          {group.label ? <div className="mb-1.5 text-xs font-medium uppercase tracking-wide text-gray-500">{group.label}</div> : null}
          <div className="flex flex-wrap gap-2">
            {group.sections.map((jump) => (
              <a
                key={jump.id}
                href={`#${jump.id}`}
                className="inline-flex items-center gap-1.5 rounded-full border border-gray-300 bg-white px-3 py-1 text-sm text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-400"
              >
                <span>{jump.label}</span>
                <span className="text-xs text-gray-500">{jump.count}</span>
              </a>
            ))}
          </div>
        </div>
      ))}
    </nav>
  );
}
